import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const loop_slider = () => {
    const swiperContainer = document.querySelector('.js-loop-swiper');
    if (!swiperContainer) return;

    const wrapper = swiperContainer.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    const originalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
    const originalCount = originalSlides.length;
    if (originalCount === 0) return;

    if (originalCount < 7) {
        const fragment = document.createDocumentFragment();
        const repeatCount = Math.ceil(7 / originalCount);

        for (let i = 1; i < repeatCount; i++) {
            originalSlides.forEach(slide => {
                fragment.appendChild(slide.cloneNode(true));
            });
        }
        wrapper.appendChild(fragment);
    }

    const swiper = new Swiper(swiperContainer, {
        modules: [Autoplay],
        loop: true,
        speed: 10000,
        spaceBetween: 40,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        freeMode: true,
        freeModeMomentum: false,
        allowTouchMove: true,

        slidesPerView: 4,
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: { slidesPerView: 4 },
        },
    });

    const wrapperEl = swiperContainer.querySelector('.swiper-wrapper');
    if (wrapperEl) {
        wrapperEl.style.transitionTimingFunction = 'linear';
    }
};

const main = () => {
    if (!document.querySelector('#page-shop-detail')) return;
    loop_slider();
};

export default main;
